import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RangeSliderComponent } from './range-slider.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [RangeSliderComponent],
  exports: [RangeSliderComponent],
})
export class RangeSliderModule {}
